import React, { Component } from 'react'
import { Box } from "@mui/material";
import {
	PieChart,
	Pie,
	Cell,
	Label,
	Tooltip,
	ResponsiveContainer,
} from "recharts";
import wyzrTheme from '../../../styles/customTheme';

// const statusColor = {
// 	"Under": "#003910",
// 	"On track": "",
// 	"Over": "#E96E66"
// }

export class PieGraph extends Component {
	constructor(props) {
		super(props);
		this.state = {
			piedata: [],
			isReady: false
		}
	}

	componentDidMount() {
		let piedata = this.props.piedata;

		piedata.forEach(element => {
			if (element.value < 0) {
				element.sign = "-";
			} else {
				element.sign = "";
			}
			element.value = Math.abs(element.value);
		}
		);	
		this.setState({ piedata: piedata, isReady: true });
	}

	render() {
		const CenterLabel = ({ viewBox, amount = 0 }) => {
			const { cx, cy } = viewBox;
			return (
				<React.Fragment>
					<text x={cx} y={cy - 10} textAnchor="middle">
						<tspan
							fill={wyzrTheme.palette.grey[500]}
							className='chart-label chart-label-xs'
						>
							{this.props.moreData.topHeading}
						</tspan>
					</text>
					<text x={cx} y={cy} dy={"0.5em"} textAnchor="middle">
						<tspan
							className='chart-label chart-label-small'

						>
							{this.props.moreData.prefix}{this.props.total} {this.props.moreData.suffix}
						</tspan>
					</text>					
				</React.Fragment>
			);
		};

		const renderCustomizedLabel = ({
			cx,
			cy,
			midAngle,
			innerRadius,
			outerRadius,
			name,
			value,
			sign,
		}) => {
			const RADIAN = Math.PI / 180;
			const radius = innerRadius + (outerRadius - innerRadius) * 0.15;
			const x = cx + radius * Math.cos(-midAngle * RADIAN);
			const y = cy + radius * Math.sin(-midAngle * RADIAN);

			const fx = x > cx ? x + 20 : x - 24;
			const fy = y > cy ? y + 20 : y - 24;

			return (
				<text
					fill="black"
					textAnchor={fx > cx ? "start" : "end"}
					dominantBaseline="central"
					>
					<tspan
						x={x > cx ? fx : fx + 7}
						y={fy}
						className={`chart-label ${name === "upcoming" || name === "remaining" ? "chart-label-big" : "chart-label-small"}`}
						>
						{this.props.moreData.prefix}{sign}{Math.round(value)}{this.props.moreData.suffix}
					</tspan>

					<tspan
						x={fx}
						y={name === "upcoming" || name === "remaining" ? fy + 24 : fy + 16}
						fill={wyzrTheme.palette.grey[500]}
						className='chart-label chart-label-small'
						
						>
						{name === "upcoming" || name === "remaining" ? "remaining" : name}
					</tspan>
				</text>
			);
		};

		return (
			<Box mt={-1.5}>
				{
					this.state.isReady ? (
				
				<ResponsiveContainer width="100%" height={220}>
					<PieChart sx={{ overflow: "visible !important" }}>
						<Pie
							data={this.state.piedata}
							label={renderCustomizedLabel}
							labelLine={false}
							outerRadius="95%"
							innerRadius="75%"
							fill="#8884d8"
							paddingAngle={0}
							dataKey="value"
							verticalAlign="center"
						>
							<Label
								content={<CenterLabel amount={Math.round(this.props.total)} />}
								position="center"
							/>
							{this.state.piedata.map((entry, index) => (
								<Cell key={index + entry} fill={this.props.colors[index % this.props.colors.length]} />
							))}
						</Pie>
						<Tooltip />
					</PieChart>


				</ResponsiveContainer>
					)
					: null }
			</Box>
		)
	}
}

export default PieGraph
